<template>
  <div>
    <a :href="link" target="_blank" rel="noopener noreferrer">
      <img :src="image" :class="{'img-active': zoneIsActive, 'img-deactive': zoneNotActive}" :style="compDelay"  />
    </a>
  </div>
</template>

<script>

export default {
  name: 'PartnersCard',
  components: {
    
  },
  props: {
    image: String,
    title: String,
    transDelay: String,
    link: String
  },
  data() {
    return {
      
    }
  },
  computed: {
    zoneIsActive() {
      return this.$store.state.activeSections.partners;
    },
    zoneNotActive() {
      return !this.$store.state.activeSections.partners;
    },
    compDelay() {
      return { 'transition-delay': this.transDelay }
    }
  }
}

</script>

<style scoped>
  div {
    border: solid yellow 0px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 320px;
    height: 140px;
  }
  
  h3 {
    text-align: center;
    margin: 30px 0px 30px 0px;
    font-weight: normal;
    transition: opacity 1000ms ease-in;
    color: rgba(0,0,0, .9);
  }
  
  .h3-active {
    opacity: 1
  }
  
  .h3-deactive {
    opacity: 0;
  }
  
  a {
    transform: scale(1);
    border: solid blue 0px;
    transition: all 100ms cubic-bezier(.75,0,.29,1.4);
  }
  
  a:hover {
    transform: scale(1.05);
  }
  
  img {
    width: 280px;
    height: auto;
    position: relative;
    transition: all 500ms cubic-bezier(.75,0,.29,1.4);
  }
  
  .img-active {
    transform: scale(1);
  }
  
  .img-deactive {
    transform: scale(0);
  }
  
  @media screen and (max-width: 800px) {
    img {
      width: 60vw;
      max-width: 280px;
    }
  }
  
  @media screen and (max-width: 450px) {
    
  }
  
  
</style>